import BaseMystery from '../BaseMystery'

const SecondSorrow = () => {
	const imagesList = [
		"https://www.wga.hu/art/c/caravagg/02/13fligh.jpg",
	];

	const titleText = "The Flight into Egypt";
	const scriptureQuote = "\"Herod is going to search for the child to destroy him.\" Joseph rose and took the child and his mother by night and departed for Egypt.";
	const scriptureCitation = "Matthew 2:13-14 (NABRE)";
	const citationLink = "https://www.biblegateway.com/passage/?search=Matthew%202%3A13-15&version=NABRE";

	return (
		<BaseMystery titleText={titleText}
				imagesList={imagesList}
				scriptureQuote={scriptureQuote}
				scriptureCitation={scriptureCitation}
				citationLink={citationLink}
				rightHanded={true} />
	);
};

export default SecondSorrow;